import React from 'react';

interface KashrutBadgeProps {
  kashrut: string;
}

const KASHRUT_STYLES: Record<string, React.CSSProperties> = {
  'פרווה':   { backgroundColor: '#e0e0e0', color: '#212121' },
  'חלבי':   { backgroundColor: '#e3f2fd', color: '#1565c0' },
  'בשרי':   { backgroundColor: '#ffebee', color: '#b71c1c' },
  'לא כשר': { backgroundColor: '#fff8e1', color: '#e65100' },
};

const DEFAULT_STYLE: React.CSSProperties = { backgroundColor: '#f3f4f6', color: '#374151' };

const badgeBaseStyle: React.CSSProperties = {
  display: 'inline-block',
  padding: '2px 8px',
  borderRadius: '12px',
  fontSize: '0.75rem',
  fontWeight: 600,
  whiteSpace: 'nowrap',
};

export function KashrutBadge({ kashrut }: KashrutBadgeProps): JSX.Element {
  const colorStyle = KASHRUT_STYLES[kashrut] ?? DEFAULT_STYLE;
  return (
    <span style={{ ...badgeBaseStyle, ...colorStyle }}>
      {kashrut}
    </span>
  );
}
